export default function ModuleTable(module) {
  const digitOnly = module.replace(/[a-zA-Z]/g, "");
  switch (digitOnly) {
    case "000":
    case "300":
    case "400":
      return "General";
    case "001":
    case "324":
    case "402":
      return "Organization";
    case "002":
    case "302":
    case "403":
      return "Auth";
    case "003":
    case "303":
    case "404":
      return "CronConfig";
    case "004":
    case "304":
    case "405":
      return "CronLog";
    case "005":
    case "305":
    case "406":
      return "RequestLog";
    case "006":
    case "407":
      return "Transmission";
    case "007":
    case "307":
    case "408":
      return "Media";
    case "008":
    case "308":
    case "409":
      return "Report";
    case "009":
    case "414":
      return "OTP";
    case "010":
      return "ConstructionSite";
    case "011":
      return "Zone";
    case "012":
      return "Document";
    case "013":
      return "OCR";
    case "014":
      return "Notification";
    case "015":
      return "SubContractor";
    case "016":
      return "Profile";
    case "017":
    case "412":
      return "User";
    case "018":
    case "413":
      return "UserGroup";
    case "019":
      return "PointCategory";
    case "020":
      return "PointItem";
    case "021":
      return "PointTransaction";
    case "022":
      return "Wallet";
    case "023":
    case "430":
      return "Service";
    case "024":
    case "431":
      return "ServiceEndpoint";
    case "025":
      return "JobTitle";
    case "026":
      return "RiskReport";
    case "027":
      return "Course";
    case "028":
      return "Certificate";
    case "029":
      return "Configuration";
    case "030":
      return "Tag";
    case "031":
      return "TagType";
    case "032":
      return "Device";
    case "033":
      return "NotificationTemplate";
    case "034":
      return "RoleAssignment";
    case "035":
      return "Test";

    // Credit Wallet Service
    case "301":
      return "System";
    case "306":
      return "TransmissionLog";
    case "320":
      return "Account";
    case "321":
      return "AccountItem";
    case "322":
      return "AccountType";
    case "323":
      return "Owner";
    case "325":
    case "439":
      return "Transaction";
    case "326":
      return "TransactionCallback";
    case "327":
      return "TransactionRequest";

    // EShop Service
    case "401":
      return "System";
    case "410":
      return "Permission";
    case "411":
      return "PermissionGroup";
    case "432":
      return "Cart";
    case "433":
      return "Currency";
    case "434":
      return "CurrencyConversion";
    case "435":
      return "Order";
    case "436":
      return "OrderActionLog";
    case "437":
      return "OrderItem";
    case "438":
      return "OrderRequest";
    case "440":
      return "PaymentMethod";
    case "441":
      return "PaymentMethodSchedule";
    case "442":
      return "SequenceTable";
    case "443":
      return "Product";
    case "444":
      return "ProductChangeLog";
    case "445":
      return "Store";
    case "446":
      return "Tags";
    case "447":
      return "ProductCategory";
    default:
      return "";
  }
}
